import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import { P2 } from '../Typography';
import { NavigationLink } from '../Link';
const Label = styled(P2) `
  width: max-content;
  color: ${({ theme }) => theme.trueBlack};

  ${media.mobile} {
    font-size: 16px;
    line-height: 24px;
  }
  ${media.tablet} {
    font-size: 16px;
    line-height: 24px;
  }
`;
export const renderLinkByType = (url, label, ariaLabel) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return React.createElement(NavigationLink, { to: (_b = (_a = url) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.href, external: ((_d = (_c = url) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.linktype) === 'external', href: (_f = (_e = url) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.href, target: (_h = (_g = url) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.target, ariaLabel: ariaLabel },
        React.createElement(Label, { field: label }));
};
